<template>
	<div id="app" class="app">
		<NavComponent v-on:changeShow="updateShow"></NavComponent>
		<transition name="fade">
			<router-view/>
		</transition>
		<LogInComponent v-on:changeShow="updateShow" :show="show">
		</LogInComponent>
	</div>
</template>

<script>
	import NavComponent from '@/components/NavComponent'
	import LogInComponent from '@/components/LogInComponent'
	import axios from 'axios'
	import store from '@/store'

	axios.interceptors.request.use(config => {
		config.headers = {
			Authorization: window.localStorage.getItem('token'),
			'Accept-Language': window.localStorage.getItem('lang')
		}
		return config
	}, error => {
		if (error.response.status === 401) {
			store.commit('userLogOut')
		}

		return Promise.reject(error)
	})

	export default {
		components: {
			NavComponent,
			LogInComponent
		},
		data () {
			return {
				show: false
			}
		},
		methods: {
			updateShow (updatedShow) {
				const body = document.querySelector('body')
				if (updatedShow && !body.classList.contains('overflow')) {
					body.classList.add('overflow')
				} else {
					body.classList.remove('overflow')
				}
				this.show = updatedShow
			}
		},
		beforeCreate () {
			if (localStorage.lang !== undefined) {
				this.$i18n.locale = localStorage.lang
			} else {
				localStorage.setItem('lang', this.$i18n.locale)
			}
		}
	}
</script>

<style lang="scss">
	@import "styles/variables.scss";
	@import "styles/container.scss";

	@font-face {
		font-family: 'Lato Regular';
		src: url('/static/fonts/Lato-Regular.eot'); /* IE9 Compat Modes */
		src: url('/static/fonts/Lato-Regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
		url('/static/fonts/Lato-Regular.woff') format('woff'), /* Pretty Modern Browsers */
		url('/static/fonts/Lato-Regular.ttf')  format('truetype'), /* Safari, Android, iOS */
		url('/static/fonts/Lato-Regular.svg#svgFontName') format('svg'); /* Legacy iOS */
	}

	@font-face {
		font-family: 'Lato Bold';
		src: url('/static/fonts/Lato-Bold.eot'); /* IE9 Compat Modes */
		src: url('/static/fonts/Lato-Bold.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
		url('/static/fonts/Lato-Bold.woff') format('woff'), /* Pretty Modern Browsers */
		url('/static/fonts/Lato-Bold.ttf')  format('truetype'), /* Safari, Android, iOS */
		url('/static/fonts/Lato-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */
	}


	@font-face {
		font-family: 'Libre Baskerville Bold';
		src: url('/static/fonts/LibreBaskerville-Bold.eot'); /* IE9 Compat Modes */
		src: url('/static/fonts/LibreBaskerville-Bold.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
		url('/static/fonts/LibreBaskerville-Bold.woff') format('woff'), /* Pretty Modern Browsers */
		url('/static/fonts/LibreBaskerville-Bold.ttf')  format('truetype'), /* Safari, Android, iOS */
		url('/static/fonts/LibreBaskerville-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */
	}

	* {
		padding: 0;
		box-sizing: border-box;
	}
	body {
		margin: 0;
	}
	.overflow {
		overflow: hidden;
	}
	#app {
		position: relative;
		font-family: $lato, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: $black;
	}
	h1,h2,h3,h4,h5,h6 {
		font-weight: 400;
	}

	input::placeholder {
		font-family: $lato;
		font-size: 16px;
		color: $gray-filter;
	}
	textarea::placeholder {
		font-family: $lato;
		font-size: 16px;
		color: $gray-filter;
	}
	input[type="color"],
	input[type="date"],
	input[type="datetime"],
	input[type="datetime-local"],
	input[type="email"],
	input[type="month"],
	input[type="number"],
	input[type="password"],
	input[type="search"],
	input[type="tel"],
	input[type="text"],
	input[type="time"],
	input[type="url"],
	input[type="week"],
	select:focus,
	textarea {
		font-family: $lato;
		font-size: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue